/**
 * 复制文本到剪贴板：优先 Clipboard API，非安全上下文回退到临时 textarea + execCommand。
 *
 * Clipboard API 只在 https / localhost 下可用，局域网 IP 访问（本项目开发时的常见形态）
 * 会直接抛错，没有回退就是「复制按钮点了没反应」。
 */
export async function copyText(text: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(text);
    return;
  } catch {
    // 非安全上下文或被权限策略拒绝，走回退
  }
  const el = document.createElement('textarea');
  el.value = text;
  el.setAttribute('readonly', '');
  el.style.position = 'fixed';
  el.style.opacity = '0';
  document.body.appendChild(el);
  el.select();
  const ok = document.execCommand('copy');
  document.body.removeChild(el);
  if (!ok) throw new Error('复制失败，请手动选中复制');
}
